/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { DomainTableRow } from './DomainTableRow';
import {
  Card,
  Form,
  Button,
  Table,
  FormCheck,
  Pagination,
  Nav,
} from 'react-bootstrap';
import { PaginationWidget } from '../../../../../../widgets/pagination-widget-react';
import toast from 'react-hot-toast';

export interface IUsersListProps {
  users: any[];
  allSelected?: boolean;
  bulkOptions?: {
    value: string;
    label: string;
  }[];
  bulkApplyLabel?: string;
  ultSelectUser?(id: string): any;
  ultSelectAllUsers(): any;
  ultDeleteUser?(id: any): any;
  ultSuspendUser?(): void;
  ultInviteUser?(): void;
  ultResetPassword?(): void;
  ultTableHeader?: string[];
  totalCount: number;
  totalPages: number;
  activePage: number;
  onPageChange?(page: number): void;
  onTogglePress?(key: string, item: any): void;
  onViewClick?(email: string): void;
}

export const UsersList = ({
  users,
  allSelected,
  bulkOptions,
  bulkApplyLabel,
  ultSelectUser,
  ultSelectAllUsers,
  ultTableHeader,
  ultDeleteUser,
  ultSuspendUser,
  onTogglePress,
  ultInviteUser,
  ultResetPassword,
  totalCount,
  totalPages,
  onPageChange,
  activePage,
  onViewClick,
}: IUsersListProps) => {
  const [bulkOption, setBulkOption] = useState<string>('');
  const disabledBulkMenu = users.filter((u) => u.isSelected).length === 0;

  const selectUser = (id) => {
    ultSelectUser && ultSelectUser(id);
  };

  const selectAllUsers = () => {
    ultSelectAllUsers && ultSelectAllUsers();
  };

  const bulkActionChange = (e) => {
    const newOption = e.target.value;
    setBulkOption(newOption);
  };

  const deleteUsers = (ids?: any) => {
    ultDeleteUser && ultDeleteUser(ids);
  };

  const suspendUsers = (ids?: any) => {
    ultSuspendUser && ultSuspendUser();
  };

  const applyBulkAction = () => {
    toast.success('Coming soon!');
    // console.log(`on apply click`, bulkOption);
    // if (bulkOption === "delete_user") {
    //   deleteUsers();
    // }
    // else if(bulkOption === "suspend_user"){
    //   suspendUsers();
    // }
    // else if(bulkOption === "invite_user"){
    //   ultInviteUser && ultInviteUser();
    // }
    // else if(bulkOption === "reset_password"){
    //   ultResetPassword && ultResetPassword();
    // }
  };

  return (
    <Card border="0" className="table-wrapper table-responsive shadow">
      <Card.Body>
        <div className="d-flex mb-3">
          <Form.Select
            className="fmxw-200"
            disabled={disabledBulkMenu}
            value={bulkOption}
            onChange={bulkActionChange}
          >
            <option value="bulk_action">Bulk Action</option>
            {bulkOptions?.map((bo, index) => (
              <option
                key={`users-list-table-bulk-option-${bo?.value}-${index}`}
                value={bo?.value}
              >
                {bo?.label}
              </option>
            ))}
          </Form.Select>
          <Button
            variant="secondary"
            size="sm"
            className="ms-3"
            disabled={disabledBulkMenu}
            onClick={applyBulkAction}
          >
            {bulkApplyLabel}
          </Button>
        </div>
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              <th className="border-bottom">
                <FormCheck type="checkbox" className="dashboard-check">
                  <FormCheck.Input
                    id="userCheckAll"
                    checked={allSelected}
                    onChange={selectAllUsers}
                  />
                  <FormCheck.Label htmlFor="userCheckAll" />
                </FormCheck>
              </th>
              {ultTableHeader?.map((header, index) => (
                <th
                  key={`ult-table-header-${header}-${index}`}
                  className="border-bottom"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="border-0">
            {users?.map((u) => (
              <DomainTableRow
                key={`user-${u.id}`}
                {...u}
                selectUser={selectUser}
                deleteUsers={deleteUsers}
                onTogglePress={onTogglePress}
                onViewClick={onViewClick}
              />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

UsersList.defaultProps = {
  users: [],
  bulkApplyLabel: 'Apply',
};
